import React from "react";
import { Select, MenuItem, Box, Typography, alpha } from "@mui/material";
import { useTranslation } from "react-i18next";
import TuneIcon from "@mui/icons-material/Tune";

interface FilterComponentProps {
  selectedFilter: string;
  customWidth?: string;
  onChange: (value: string) => void;
}

const FilterComponent: React.FC<FilterComponentProps> = ({ selectedFilter, customWidth, onChange }) => {
  const { t } = useTranslation();
  const hoverColor = "#F4701B";
  const hoverBackgroundColor = alpha(hoverColor, 0.1);

  return (
    <Box sx={{ display: "flex", alignItems: "center", width: { xs: customWidth || "auto", md: "auto" } }}>
      <Select
        sx={{
          position: "relative",
          backgroundColor: "#F6F7FB",
          color: "#6D6777",
          fontFamily: "var(--cygreRegular), sans-serif",
          fontSize: "14px",
          boxShadow: "none",
          textTransform: "none",
          height: 40,
          width: { xs: "100%", md: "140px" },
          borderRadius: "8px",
          border: "none",
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&:hover": {
            backgroundColor: hoverBackgroundColor,
            color: hoverColor,
            "& .MuiSvgIcon-root": {
              color: hoverColor,
            },
          },
        }}
        value={selectedFilter}
        onChange={(e) => onChange(e.target.value)}
        MenuProps={{
          container: document.getElementById("root"),
        }}
        displayEmpty
        renderValue={() => (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <TuneIcon sx={{ marginRight: "8px", color: "#6D6777" }} />
            <Typography sx={{ color: "#6D6777", fontFamily: "var(--cygreRegular), sans-serif", fontSize: "14px" }}>
              {t("filter")}
            </Typography>
          </Box>
        )}
      >
        <MenuItem value="all">{t("all")}</MenuItem>
        <MenuItem value="unique">{t("unique")}</MenuItem>
        <MenuItem value="installs">{t("installs")}</MenuItem>
        <MenuItem value="clicks">{t("clicks")}</MenuItem>
        <MenuItem value="uniqueClicks">{t("uniqueClicks")}</MenuItem>
        <MenuItem value="regs">{t("regs")}</MenuItem>
        <MenuItem value="deps">{t("deps")}</MenuItem>
      </Select>
    </Box>
  );
};

export default FilterComponent;
